export const SIDEBAR_LS_KEY = 'convo_sidebar'
